<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('manageGeneral.title') }}</h6>
          <p class="font13 gray-col">{{ $t('manageGeneral.subtitle') }}</p>
        </div>
        <router-link to="/sendNotifications" class="main-btn up lg"
          >{{ $t('manageGeneral.sendNotifications') }}</router-link
        >
      </div>
      <div class="white-box-pad mb-3">
        <h6 class="mb-0 color-main">{{ $t('manageGeneral.tenantMessages') }}</h6>
      </div>
      <div class="white-box-pad no-pad" v-if="!loader">
        <template v-if="messages.length">
          <div
            class="loop-message"
            v-for="message in messages"
            :key="message.id"
          >
            <div class="flex-bet-main mb-3">
              <div class="client-name font-bold color-main">
                {{ message.user_name }}
              </div>
              <div class="message-time font13 gray-col">
                <i class="fa-regular fa-clock"></i>
                <div>{{ message.created_dt }}</div>
              </div>
            </div>
            <div class="gray-col mb-2">
              {{ $t('manageGeneral.messageSubject') }}: {{ message.subject }}
            </div>
            <div class="gray-col mb-2">{{ $t('manageGeneral.messageContent') }}:</div>
            <p class="gray-col mb-0">
              {{ message.text }}
            </p>
          </div>
        </template>
        <noData v-else  />
      </div>
      <div class="bg-white-div" v-else>
        <Skeleton width="100%" height="80px" class="mb-3"></Skeleton>
        <Skeleton width="100%" height="80px" class="mb-3"></Skeleton>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import noData from "../components/dashboard/noData.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";

import { onMounted, ref } from "vue";

// reactive state
const messages = ref([]);
const loader = ref(false);
// const noDataImg = ref(require("@/assets/imgs/7486744.png"));

// functions
function getMessages() {
  loader.value = true;
  axios
    .get(`/manager/messages`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      messages.value = response.data.data;
      loader.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getMessages();
});
</script>
